import {Injectable} from '@angular/core';
import {Actions, createEffect, ofType} from '@ngrx/effects';
import {Store} from "@ngrx/store";
import {AppState} from "../../../shared/state/app.state";
import {BuildKitService} from "../../data-access/build-kit.service";
import {catchError, map, mergeMap, switchMap} from "rxjs/operators";
import {of} from "rxjs";
import {
  downloadBuildKitReport,
  downloadBuildKitReportFailure,
  downloadBuildKitReportSuccess,
  generateBuildKitReport,
  generateBuildKitReportFailure,
  generateBuildKitReportSuccess,
  loadBuildKitReports,
  loadBuildKitReportsFailure,
  loadBuildKitReportsSuccess,
  loadBuildKitReportValidationMessages,
  loadBuildKitReportValidationMessagesFailure,
  loadBuildKitReportValidationMessagesSuccess
} from "./build-kit-report.action";
import {ReportService} from "../../../report/data-access/report.service";


@Injectable()
export class BuildKitReportEffects {
  loadBuildKitReports$ = createEffect(() =>
    this.actions$.pipe(
      ofType(loadBuildKitReports),
      switchMap(({buildKitId}) =>
        this.buildKitService.getReportsByBuildKit(buildKitId)
          .pipe(
            map((buildKitReports) => loadBuildKitReportsSuccess({buildKitReports: buildKitReports})),
            catchError((error) => of(loadBuildKitReportsFailure({ error })))
          )
      )
    )
  );

  downloadBuildKitReport$ = createEffect(() =>
    this.actions$.pipe(
      ofType(downloadBuildKitReport),
      switchMap((action) => {
          return this.reportService.download(action.reportId, action.fileName)
            .pipe(
              map((file) => downloadBuildKitReportSuccess({file: file, buildKitId: action.buildKitId, reportType: action.reportType})),
              catchError((error) => of(downloadBuildKitReportFailure({error, buildKitId: action.buildKitId, reportType: action.reportType})))
            )
        }
      )
    )
  );

  generateBuildKitReport$ = createEffect(() =>
    this.actions$.pipe(
      ofType(generateBuildKitReport),
      mergeMap((action) =>
        this.reportService.generate(Number(action.buildKitId), action.reportType, action.fileName, action.settings)
          .pipe(
            map((response) => generateBuildKitReportSuccess({ buildKitReport: response?.data })),
            catchError((error) => of(generateBuildKitReportFailure({ error: error, buildKitId: action.buildKitId, reportType: action.reportType })))
          )
      )
    )
  );

  loadBuildKitReportReportValidationMessages$ = createEffect(() =>
    this.actions$.pipe(
      ofType(loadBuildKitReportValidationMessages),
      switchMap((action) => {
          return this.reportService.getReportWithValidationMessages(action.reportId)
            .pipe(
              map((response) => {
                return loadBuildKitReportValidationMessagesSuccess({
                  buildKitReport: (response as any)
                })
              }),
              catchError((response) => of(loadBuildKitReportValidationMessagesFailure(
                {
                  error: response
                }
              )))
            )
        }
      )
    )
  );

  constructor(
    private actions$: Actions,
    private store: Store<AppState>,
    private buildKitService: BuildKitService,
    private reportService: ReportService,
  ) {}
}
